import { render, staticRenderFns } from "./EditWorkstationPage.vue?vue&type=template&id=2749b8a3"
import script from "./EditWorkstationPage.vue?vue&type=script&lang=js"
export * from "./EditWorkstationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports